import { render, staticRenderFns } from "./no.vue?vue&type=template&id=20c1955e&scoped=true&"
import script from "./no.vue?vue&type=script&lang=js&"
export * from "./no.vue?vue&type=script&lang=js&"
import style0 from "./no.vue?vue&type=style&index=0&id=20c1955e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c1955e",
  null
  
)

export default component.exports